<template>
    <div>
       <span class="fw-bold">{{ label }}</span>
     <slot />
    </div>
</template>

<script>
export default {
  name: "FormLayoutPanel",
  props: {
    label: {
      type: String,
      required: true
    },
  }
}
</script>
